import Vue from 'vue';
import Vuex from 'vuex';
import globalConfig from 'shared/store/globalConfig';
import online99Extra from 'dashboard/store/modules/online99Extra';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    globalConfig,
    online99Extra,
  },
});
